module.exports = __webpack_public_path__ + "img/jixi-02ceaf.png";